import moment from 'moment'

const ERROR_CONCAT = 'error_concat'
const ERROR_ADD_ALL = 'error_all'

const registeredErrorMessages = {
    alreadyRegistered: ERROR_CONCAT,
    paypalUnauthorized: ERROR_CONCAT,
    questionAnswerNotAvailable: ERROR_ADD_ALL,
    quantityAnswerNotAvailable: "name",
    groupRegistrarTokenMismatch: false,
    groupParticipantTokenMismatch: false,
    caregiverTokenMismatch: false,
    noCheckTokenTokenMismatch: false,
    notEnoughPlacesForFemaleParticipantsLeft: false,
    notEnoughPlacesForMaleParticipantsLeft: false,
    notEnoughPlacesForParticipantsLeft: false,
    notEnoughPlacesLeft: false,
    invalidIban: false,
    invalidCaregiverUuid: false,
    alreadyRedeemedCouponCode: false,
    incompatibleCouponCode: false,
    wrongCouponCode: false,
    invalidPaymentType: false,
    not_authorized: false,
    participantCanNotBeDeleted: "name",
    registrationTransactionError: false,
    blockedByAsyncRequest: false,
}

export default {
    async fetchEventData({commit, state, getters}, {eventId, loadRemainingFreePlacesOnly = false}) {
        const {$axios, $apiRoute} = useNuxtApp()

        try {
            if (!loadRemainingFreePlacesOnly) {
                commit('setEventIsLoaded', false)
                let responseData = (await $axios.get($apiRoute('api.registration.veranstaltung.show', {veranstaltung: eventId}),
                    {
                        params: {
                            preview: state.previewMode,
                            caregiverToken: state.caregiverToken,
                            caregiverCheckToken: state.caregiverCheckToken,
                            groupRegistrarToken: state.groupRegistrarToken,
                            groupParticipantToken: state.groupParticipantToken,
                            noCheckToken: state.noCheckToken
                        }
                    }
                )).data

                commit('setEventData', responseData.eventData)
                commit('setRemainingPlaces', responseData.remainingPlaces)
                commit('setAvailabilities', responseData.availabilities)
                commit('setReservedPlaces', responseData.reservedPlaces)
                commit('setReservedAvailabilities', responseData.reservedAvailabilities)
                commit('setOccupancy', responseData.occupancy)
                commit('setFormSelectChoices', responseData.formSelectChoices)
                commit('setOnlineRegistrationFields', responseData.onlineRegistrationFields)

                if (responseData.caregiver) {
                    commit('setCaregiver', responseData.caregiver)
                }
                if (responseData.caregiverOptions) {
                    commit('setCaregiverOptions', responseData.caregiverOptions)
                }
                if (responseData.registrationData) {
                    commit('setRegistrationData', responseData.registrationData)
                    commit('setInitialFemalePlacesTaken', getters.getNumberOfTakenFemalePlaces)
                    commit('setInitialMalePlacesTaken', getters.getNumberOfTakenMalePlaces)
                    commit('setInitialTotalPlacesTaken', getters.getNumberOfTakenPlacesTotal)
                    commit('setInitialAnswerSelections', getters.getAnswerSelectionsInRegistration)
                }
                if (responseData.ci) {
                    useNuxtApp().$applyCi(responseData.ci, {standalone: true})
                }
            } else {
                let eventData = (await $axios.get($apiRoute('api.registration.veranstaltung.show', {veranstaltung: eventId}),
                    {
                        params: {
                            loadRemainingFreePlacesOnly: true,
                            preview: state.previewMode
                        },
                        progress: false
                    }
                )).data

                // TODO Bug? why would we set the eventData here?
                // commit('setEventData', eventData)
                commit('setRemainingPlaces', eventData.remainingPlaces)
                commit('setAvailabilities', eventData.availabilities)
                commit('setReservedPlaces', eventData.reservedPlaces)
                commit('setReservedAvailabilities', eventData.reservedAvailabilities)
                commit('setOccupancy', eventData.occupancy)
            }

            commit('setEventIsLoaded', true)

        } catch (error) {
            console.log(error)
            if (error.response) {
                if (error.response.status === 404) {
                    showError({statusCode: 403, message: "not_found"})
                } else if (error.response.status === 403) {
                    showError({statusCode: 403, message: error.response.data?.message, data: error.response.data})
                } else if (error.response.status === 500) {
                    showError({statusCode: 500})
                }
            } else {
                console.log(error)
            }
        }
    },

    async sendRegistration({commit, state}) {
        const {$axios, $apiRoute, $notify, $i18n} = useNuxtApp()
        if (!state.eventData?.id) {
            $notify({
                type: 'danger',
                message: $i18n.t('error.noEventData'),
                timeout: 15000
            })
            return;
        }
        try {
            commit('setEventIsLoaded', false)
            const response = await $axios.post($apiRoute('api.registration.veranstaltung.registration.store', {veranstaltung: state.eventData.id}),
                state.registrationData
            )
            commit('setRegistrationProp', {prop: "id", value: response.data.id})
            commit('setRegistrationProp', {prop: "requestId", value: response.data.requestId})
            commit('setRegistrationProp', {prop: "openRequests", value: response.data.openRequests})
            commit('setRegistrationFinishedSuccessful', true)
            commit('setEventIsLoaded', true)

            if (response.status === 202) {
                $notify({
                    type: 'warning',
                    message: $i18n.t('error.conflictInPostRegistration'),
                    timeout: 15000
                })
            }
        } catch (e) {
            commit('setEventIsLoaded', true)

            const message = e.response?.data?.message ?? null
            const status = e.response?.status ?? null
            let errorType = registeredErrorMessages[message] ?? null

            if (status === 429) {
                commit('setRetryAfter', e.response?.data?.retry_after ?? null)
                commit('setTooManyAttempts', moment().toISOString())

                $notify({
                    type: 'warning',
                    message: $i18n.t('error.tooManyRequests'),
                    timeout: 10000
                })
                return
            }

            if (message && $i18n.te('error.' + message)) {
                const additionalData = e.response.data.additionalData
                let errorMessage = $i18n.t('error.' + message)
                if (errorType === ERROR_CONCAT)
                    errorMessage = $i18n.t('error.' + message) + " " + additionalData
                else if (errorType === ERROR_ADD_ALL)
                    errorMessage = $i18n.t('error.' + message, additionalData)
                else if (errorType)
                    errorMessage = $i18n.t('error.' + message, {[errorType]: additionalData})

                $notify({
                    type: 'danger',
                    message: errorMessage,
                    timeout: 15000
                })

                if (message === "alreadyRegistered") {
                    navigateTo(
                        {
                            path: useLocalePath()({name: 'registration-id-participants'}),
                            query: useRoute().query
                        })
                }
            } else if (status === 422 && !!message) {
                $notify({
                    type: 'warning',
                    message: $i18n.t('error.invalidRegistrationData') + ' (' + message + ')',
                    timeout: 15000
                })
                sendFailRegistrationInfo(state, e)
            } else {
                $notify({type: 'danger', message: $i18n.t('error.errorWhileRegistraton'), timeout: 15000})
                sendFailRegistrationInfo(state, e)
            }
        }
    },

    async checkRequestState({commit, state}, {eventId}) {
        const {$axios, $apiRoute} = useNuxtApp()

        if (!eventId || !state.registrationData.requestId) return

        try {
            const response = await $axios.get(
                $apiRoute('api.registration.veranstaltung.checkRequest',
                    {veranstaltung: eventId}
                ),
                {params: {requestId: state.registrationData.requestId}}
            )

            commit('setRegistrationProp', {prop: "id", value: response.data.id})
            commit('setRegistrationProp', {prop: "requestId", value: response.data.requestId})
            commit('setRegistrationProp', {prop: "openRequests", value: response.data.openRequests})
            commit('setRegistrationProp', {prop: "requestFailure", value: response.data.requestFailure})
        } catch (e) {
            console.log(e)
            // $notify({type: 'danger', message: $i18n.t('error.errorWhileCheckingRequestState'), timeout: 15000})
        }
    },

    async getEncryptedPersonalData({commit, state}) {
        const {$axios, $apiRoute} = useNuxtApp()

        if (!state.eventData?.id) return null

        // check if only one person is registered, and if that person also matches the invoice recipient
        if (state.registrationData.participatingPersons?.length !== 1) return null

        let personToEncrypt = null

        const participant = state.registrationData.persons[state.registrationData.participatingPersons[0]]

        if (!state.groupRegistrarToken) personToEncrypt = participant

        if (!state.groupParticipantToken && state.registrationData.persons?.invoiceRecipient) {
            // persons do not have ids, use name as identifier
            const invoiceRecipient = state.registrationData.persons.invoiceRecipient

            if (state.groupRegistrarToken || (invoiceRecipient.firstname === participant.firstname &&
                invoiceRecipient.lastname === participant.lastname)) {
                personToEncrypt = invoiceRecipient
            }
        }

        if (!personToEncrypt) return null

        commit('setEventIsLoaded', false)

        const personData = {
            person: personToEncrypt,
            payment: state.groupParticipantToken ? {
                accountHolder: personToEncrypt.firstname + ' ' + personToEncrypt.lastname,
            } : {
                iban: state.registrationData.iban,
                alternativeAccountHolder: state.registrationData.alternativeAccountHolder,
                accountHolder: state.registrationData.alternativeAccountHolder ?? (personToEncrypt.firstname + ' ' + personToEncrypt.lastname),
            }
        }

        try {
            const response = await $axios.post(
                $apiRoute('api.registration.veranstaltung.registration.encrypt', {veranstaltung: state.eventData.id}),
                personData
            )

            commit('setEventIsLoaded', true)
            return response.data
        } catch (e) {
            console.log(e)
        }
        commit('setEventIsLoaded', true)
        return null;
    }
}


function sendFailRegistrationInfo(state, error) {

    const {$axios, $apiRoute} = useNuxtApp()
    $axios.post($apiRoute('api.registration.registrationFailure'), {
        registrationVueData: state,
        registrationResponse: error?.response ? error.response : null,
        registrationRequest: error?.request ? error.request : null,
        registrationRequestConfig: error?.config ? error.config : null,
        registrationRequestMessage: error?.message ? error.message : null
    })
}
